/**
 * Nomes de módulos e ações, para as mensagens da interface.
 *
 * Espelha config/permissoes.php do servidor. A duplicação existe porque a rota
 * que devolve o catálogo é restrita a quem administra usuários, e a mensagem
 * precisa aparecer justamente para quem não tem esse acesso. São nomes fixos,
 * que mudam junto com os módulos do sistema, e não a cada configuração.
 */

export const ROTULO_MODULO: Record<string, string> = {
  veiculos: 'Veículos',
  motoristas: 'Motoristas',
  abastecimentos: 'Abastecimentos',
  manutencoes: 'Manutenções',
  despesas: 'Financeiro',
  viagens: 'Viagens',
  anexos: 'Anexos',
  relatorios: 'Relatórios',
  aprovacoes: 'Aprovação de motoristas',
  usuarios: 'Usuários e permissões',
  auditoria: 'Trilha de auditoria',
  notificacoes: 'Notificações',
};

/** Como cada ação é dita na frase, com :modulo no lugar do módulo. */
export const FRASE_ACAO: Record<string, string> = {
  consultar: 'consultar :modulo',
  criar: 'criar registros em :modulo',
  editar: 'editar registros em :modulo',
  excluir: 'excluir registros em :modulo',
  exportar: 'exportar :modulo',
  pagar: 'dar baixa em :modulo',
  iniciar: 'iniciar registros em :modulo',
  finalizar: 'finalizar registros em :modulo',
  cancelar: 'cancelar registros em :modulo',
  aprovar: 'aprovar cadastros em :modulo',
  rejeitar: 'rejeitar cadastros em :modulo',
};

export const fraseDaPermissao = (modulo: string, acao: string): string => {
  const rotulo = ROTULO_MODULO[modulo] || modulo;
  const molde = FRASE_ACAO[acao] || `${acao} em :modulo`;
  return molde.replace(':modulo', rotulo);
};
